import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticClass:"text-center",attrs:{"color":_vm.getOperationColor().backgroundColor}},[_c('span',{staticClass:"text-no-wrap text-center",style:(_vm.getOperationColor())},[_vm._v("\n    "+_vm._s(_vm.getLocalizedOperationType(_vm.operationType))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }